import React from 'react';
import ItemMenu from './item_menu';

export default class SubcategoriaMenu extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            visible: false
        }
        this.visualizarSubcategoria = this.visualizarSubcategoria.bind(this);
    }

    visualizarSubcategoria(event){
        event.preventDefault();
        this.setState({
            visible: !this.state.visible
        })
    }

    render(){
        return(
            <li>
                <h4 onClick={this.visualizarSubcategoria}>
                    {this.props.nombre_subCateg}
                </h4>      
                <ul className={this.state.visible?'visible': 'no-visible'}>
                    {this.props.items.map((item)=> {                        
                        return <ItemMenu nombre_item={item.NombreMenu} link_item={item.Ruta} key={item.CodigoMenu}/>
                    })}
                </ul>
            </li>
        );
  }
}

